import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../auth/UseUser";

const AdminRoute = ({ Component }: any) => {
  const { isSignedIn, user } = useUser();
  
  if (!isSignedIn) {
    return <Navigate to="/login" />;
  }
  
  const isAdmin = user?.roleView?.name?.includes("Администратор");
  
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }
  
  return <Component />;
};

export default AdminRoute;